// import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import App, { restore } from './App';

restore().then(() => {
  // Render the main component into the dom
  ReactDOM.render(<App />, document.getElementById('app'));
});



// WEBPACK FOOTER //
// ./src/index.jsx